module.exports = __webpack_public_path__ + "86ebee851597c60bc66b13c8fca1977a.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/amplification/social-fb.png
// module id = 3283
// module chunks = 69